<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#gateway_list"
                           @click="gotoTab(1)">
                            {{ $t('deposit.gateway_list') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#settings"
                           @click="gotoTab(2)">
                            {{ $t('aside.settings') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="#gateway_list">
                    <div style="margin-top: 15px" id="gateway_list" aria-labelledby="gateway_list"
                         data-parent="#gateway_list">
                        <gateways-filter :action="filterAction"></gateways-filter>
                        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
                    </div>
                </div>
            </div>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 2 ? 'active' : '']" id="#settings">
                    <div style="margin-top: 15px" id="settings" aria-labelledby="settings"
                         data-parent="#settings">
                        <settings></settings>
                    </div>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import columns from './../datatable/columns'
import {StarShopApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import actionsColumn from './actions-column'
import gatewaysFilter from './gateways-filter.vue'
import settings from './settings.vue'

export default {

    components: {
        'gateways-filter': gatewaysFilter,
        settings
    },
    data() {
        return {
            query: {},
            currentTab: 1
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "deposit_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: StarShopApiUrl.path('card-to-card/admin/gateway'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        gotoTab(index) {
            this.currentTab = index;
        }
    }
}
</script>

<style>

</style>